export default __webpack_public_path__ + "static/media/playground-banner.eb02a808.png";